<header class="header">
  <div class="container header-container">
    <!-- Mobile menu toggle -->
    <button class="header-menu-toggle" aria-label="Abrir menú" (click)="toggleMenu()">
      <fa-icon [icon]="faBars"></fa-icon>
    </button>

    <!-- Logo -->
    <a routerLink="/" class="header-logo">
      <img src="/assets/images/logo-gestion-espacios-horizontal.png" alt="Citylok espacios" />
    </a>

    <!-- Desktop Navigation -->
    <nav class="header-nav" aria-label="Navegación principal">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Inicio</a>
      <a routerLink="/espacios" routerLinkActive="active">Espacios</a>
      @if (authStore.isAuthenticated()) {
        <a routerLink="/mis-reservas" routerLinkActive="active">Mis reservas</a>
      }
      <a routerLink="/ayuda" routerLinkActive="active">Ayuda</a>
    </nav>

    @if (!authStore.isAuthenticated()) {
      <a routerLink="/login" class="app-btn app-btn--primary app-btn--sm header-access-btn">Acceder</a>
    } @else {
      <div class="header-user-panel">
        <app-notification-bell></app-notification-bell>
        <a [routerLink]="userProfileRoute" class="header-account-card">
          <div class="header-account-card__copy">
            <strong>{{ userDisplayName }}</strong>
            <span>{{ userSubtitle }}</span>
          </div>
          <span class="header-account-card__avatar">
            @if (authStore.user()?.image_url) {
              <img [src]="authStore.user()?.image_url || ''" alt="Imagen de perfil" />
            } @else {
              {{ userInitials }}
            }
          </span>
        </a>
      </div>
    }

    <!-- Mobile User Icon -->
    <a
      [routerLink]="authStore.isAuthenticated() ? userProfileRoute : '/login'"
      class="header-user-icon"
      [class.header-user-icon--guest]="!authStore.isAuthenticated()"
      aria-label="Menú de usuario"
    >
      <fa-icon [icon]="faUser"></fa-icon>
    </a>
  </div>
</header>
